<template>
    <button class="get-started-btn"><slot /></button>
</template>

<style scoped lang="scss">
.get-started-btn {
  font-size: 26px;
  color: $AC_White;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background-color: $AC_Navy;
  border: 3px solid $AC_White;
  border-radius: 10px;
  padding: 15px 66px 14px;
  cursor: pointer;
  position: relative;
  z-index: 1;

  @media (min-width: 1025px) {
    font-size: 31px;
    padding: 17px 75px 16px;
  }

  &:not(:disabled) {
    &:hover,
    &:focus {
      box-shadow: 0 3px 20px rgba(226, 86, 38, 0.75);
    }
  }

  &:disabled {
    cursor: default;
  }
}
</style>
